const { Serializer } = require("jsonapi-serializer");

module.exports = {
  PatrimonialApprovedSerializer: (meta = {}) =>
    new Serializer("patrimonialApprovedSerializer", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["email", "amount_fng"]
    })
};
